import { Summary } from 'RevenueRecognition/view/common/Summary'

import {
  Text,
  GreyGrey70,
  IconBuildings,
  Image,
  IndigoIndigo60,
  Link,
  Pill,
  PopoverWrapper,
  Primary13Regular
} from '@sequencehq/core-components'
import { CustomerPreviewCard } from 'Customer/components/CustomerPreviewCard'
import { useDefRevScheduleSummary } from 'RevenueRecognition/view/deferredRevenueDashboard/content/recognitionDrawerLayouts/common/useDefRevScheduleSummary'
import { getLogoSrc } from 'Customer/utils/logo'
import { format } from '@sequencehq/utils/dates'
import { humanize } from 'inflection'

export const DeferredRevenueDetailDrawerSummary = ({
  defRevScheduleId
}: {
  defRevScheduleId: string
}) => {
  const { isLoading, summary } = useDefRevScheduleSummary({
    scheduleId: defRevScheduleId
  })

  const summaryRows = [
    {
      title: 'Customer',
      value: summary?.customer ? (
        <PopoverWrapper
          popover={<CustomerPreviewCard customerId={summary.customer.id} />}
          offset={[-4, 4]}
          openDelay={850}
        >
          <Link.Unstyled
            to={`/customers/${summary.customer.id}`}
            data-testid="revrec.journalDetailOverview.summary.customer"
          >
            <Pill
              icon={
                summary.customer.domain ? (
                  <Image
                    height="16px"
                    width="16px"
                    src={getLogoSrc({
                      domain: summary.customer.domain
                    })}
                  />
                ) : (
                  <IconBuildings color={GreyGrey70} />
                )
              }
              interactive
              variant="ghost"
            >
              {summary.customer.name}
            </Pill>
          </Link.Unstyled>
        </PopoverWrapper>
      ) : (
        '-'
      )
    },
    {
      title: 'Invoice',
      value: summary?.invoice ? (
        <Link.Unstyled
          to={`/invoices/${summary.invoice.id}`}
          data-testid="revrec.journalDetailOverview.summary.product"
        >
          <Text
            {...Primary13Regular}
            color={IndigoIndigo60}
            fontWeight="semibold"
          >
            {summary.invoice.name}
          </Text>
        </Link.Unstyled>
      ) : (
        '-'
      )
    },
    {
      title: 'Product',
      value: summary?.product ? (
        <Link.Unstyled
          to={`/products/${summary.product.id}`}
          data-testid="revrec.journalDetailOverview.summary.product"
        >
          <Text
            {...Primary13Regular}
            color={IndigoIndigo60}
            fontWeight="semibold"
          >
            {summary.product.name}
          </Text>
        </Link.Unstyled>
      ) : (
        '-'
      )
    },
    {
      title: 'Method',
      value: summary?.method ? humanize(summary.method) : '-'
    },
    {
      title: 'Recognition term',
      value: summary?.recognitionTerm
        ? format(summary.recognitionTerm.start, 'd MMM yyyy') +
          ' - ' +
          format(summary.recognitionTerm.end, 'd MMM yyyy')
        : ''
    }
  ]

  return <Summary rows={summaryRows} isLoading={isLoading} />
}
